import { call, select } from 'redux-saga/effects';

import { showLoader, hideLoader, attachLoader } from '../utils/loaderUtil';

export function *attachLoaderSaga(component, store) {
    const f = attachLoader.bind(component);

    yield call(f, store);
}

export function *showLoaderSaga(component = {}) {
    yield call(showLoader, component);
}

export function *hideLoaderSaga(component = {}) {
    yield call(hideLoader, component);
}

/**
 * @param saga - What saga to run.  You should pass a *call* object.
 *   ie: const callSaga = call(sagaToRun, options, options, options)
 * @param component - What component to attach the loader to
 */
export function *loaderSaga(saga, component, store) {
    try {
        yield call(attachLoaderSaga, component, store);
        yield call(showLoaderSaga, component);
        yield saga;
    } finally {
        yield call(hideLoaderSaga, component);
    }
}
